module.exports = __webpack_public_path__ + "img/qtv_logo.8c635a57.png";